// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2S0c3","header":"Messages_header__3TJxN"};